import { Directive, ElementRef, Input, OnInit, OnDestroy, inject } from '@angular/core';

@Directive({
  selector: '[sasScrollToBottom]',
  standalone: true
})
export class ScrollToBottomDirective implements OnInit, OnDestroy {
  private readonly elementRef = inject(ElementRef);
  
  @Input() sasScrollToBottom: boolean = true;
  @Input() smooth: boolean = false;
  @Input() auto: boolean = false;
  
  private observer?: MutationObserver;

  ngOnInit() {
    if (this.auto) {
      this.setupAutoScroll();
    }
    
    if (this.sasScrollToBottom) {
      this.scrollToBottom();
    }
  }

  ngOnDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  public scrollToBottom() {
    const element: HTMLElement = this.elementRef.nativeElement;
    
    if (this.smooth) {
      element.scrollTo({
        top: element.scrollHeight,
        behavior: 'smooth'
      });
    } else {
      element.scrollTop = element.scrollHeight;
    }
  }

  private setupAutoScroll() {
    const element: HTMLElement = this.elementRef.nativeElement;
    
    // Observar cambios en el contenido para hacer scroll automático
    this.observer = new MutationObserver(() => {
      if (this.sasScrollToBottom) {
        this.scrollToBottom();
      }
    });

    this.observer.observe(element, {
      childList: true,
      subtree: true
    });
  }
}
